<template>
  <div>
    <!-- Because this component is also displayed in a pre-built card within events, a label is not always necessary -->
    <!-- Therefore, the label is only displayed when a specific config enables it -->
    <FormLabel
      v-if="label && config.showLabel"
      v-bind="{
        label,
        required,
        disabled,
        description,
        descriptionType,
        dirty,
        error,
        id,
        status
      }"
    />
    <FormArrayValidationGroup @validation="$emit('validation', $event)">
      <template #default="{ updateValidation, nestedValidationsByIndex }">
        <FormList
          ref="list"
          :value="value"
          :disabled="disabled"
          :validation="nestedValidationsByIndex"
          @input="$emit('input', $event)"
        >
          <!-- eslint-disable-next-line vue/no-unused-vars -->
          <template #default="{ isRead, isEdit, item, index, updateItem }">
            <SchemaForm
              :disabled="disabled || isRead"
              :value="item"
              :fields="fields"
              :validation="true"
              dirtyOn="blur"
              @validation="updateValidation(index, ...arguments)"
              @input="updateItem(index, $event)"
            />
          </template>
        </FormList>
      </template>
    </FormArrayValidationGroup>
    <AppButton
      v-if="!disabled"
      @click="add"
    >
      <AppIcon name="add" />
      <span>Add new contact</span>
    </AppButton>
  </div>
</template>

<script>
import _without from 'lodash/without'
import FormList from './FormList'
import FormContactsListActions from './FormContactsListActions'
import contactFields from '@/constants/specialTypesFields/contact'
import FormArrayValidationGroup from '@/components/Forms/FormArrayValidationGroup'
import FormLabel from './FormLabel'
import FormMixin from './FormMixin'

export default {
  inheritAttrs: false,
  mixins: [ FormMixin ],
  components: {
    /*
    We have to dynamically import SchemaForm because it is also used
    within the EventManagement/Form.vue component, a parent to this component -
    which causes SchemaForm to be both a parent and child of iteself, leading to
    the following import error in this component:
    Unknown custom element: <SchemaForm> - did you register the component correctly?
    For recursive components, make sure to provide the "name" option.

    The dynamic import resolves the issue, as it prevents prevents an interdependency loop
    */
    SchemaForm: () => import('@/components/Forms/Form'),
    FormList,
    FormArrayValidationGroup,
    FormLabel,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      default: () => ({
        showLabel: false,
        useOnlyFieldsFromConfig: false,
      }),
    },
  },
  computed: {
    fields () {
      const defaultFields = contactFields({
        config: this.config,
      })

      const deleteField = {
        component: FormContactsListActions,
        class: 'mt-4',
        listeners: { delete: this.delete },
      }
      if (this.config.useOnlyFieldsFromConfig) return Object.values(this.config.fields || {}).concat({ ...deleteField, style: 'flex-grow: 0.1; flex-basis: 30px' })
      return [
        [
          {
            ...defaultFields.name, style: 'flex-grow: 4',
          },
          {
            ...defaultFields.email, style: 'flex-grow: 4',
          },
          {
            ...defaultFields.phone, style: 'flex-grow: 3.5',
          },
          { ...deleteField, style: 'flex-grow: 0.5; flex-basis: 60px;' },
        ],
        {
          ...defaultFields.address, style: 'flex-grow: 4;', class: 'w-100',
        },
        defaultFields.notify,
      ]
    },
  },
  methods: {
    add () {
      this.$emit('input', [ ...(this.value || []), { notify: this.config.sendEmailNotifications || false } ])
    },
    delete (item) {
      this.$emit('input', _without(this.value, item))
    },
  },
}
</script>
